import React, { Component } from 'react';
import { Router, Switch, Route, Redirect } from 'react-router-dom';
import history from './Routers/history';
import './app.scss';
import Pages from './Pages';
import Login from './Pages/Login';

class App extends Component {
  isLoggedIn = (props) => {
    if(props?.location?.search?.includes('ad_token')){
      localStorage.removeItem('id_token')
    }
    const token = localStorage.getItem('id_token');
    if (token === undefined || token === null) {
      return false;
    } else {
      return true;
    }
  };

  render() {
    return (
      <Router history={history}>
        <Switch>
        <Route exact path="/login" render={props => {
          let loginProps = { ...props, state: {azure: window.location.search } }
          return <Login {...loginProps}/>
          // return this.isLoggedIn(props) ? (
          //     <Redirect to="/" />
          //   ) : (
          //       <Login {...loginProps}/>
          //     )
        }}
          />
          <Route path="/" name="Dashboard" render={props => {
            return this.isLoggedIn(props) ? (
              <Pages {...props} />
            ) : (
              <Redirect 
                to={{
                  pathname: "/login",
                  state: {
                    azure: props.location.search,
                  }
                }}
              />              )
          }}
          />
        </Switch>
      </Router>
    );
  }
}

export default App;
